module.exports = __webpack_public_path__ + "static/img/header.12a25ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zhangmen/header.png
// module id = tsAA
// module chunks = 5